// extracted by mini-css-extract-plugin
export var label = "_e9-2";
export var slideContainer = "_e9-0";
export var slider = "_e9-1";